module.exports = __webpack_public_path__ + "media/src/Shared/Assets/rvshare_logo-60e58c4f216befba12cc185b7f28ced22ab13c9b67984bb7cd38bf04fe1c3988.svg";